import {List, Map} from 'immutable';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import * as basketActions from "../actions/basketActions";
import {bindActionCreators} from "redux";
import ProductCustomizeView from '../components/Product/ProductCustomizeView';
import * as _ from 'lodash';
import {getCrustOfPizza, getSizeOfPizza} from '../helpers';
import {DEFAULT_SIZE_PIZZA, LIMIT_INGREDIENTS} from "../constants";
import Spinner from '../components/Spinner/Spinner';


class ProductCustomizeScreen extends Component {

  constructor(props) {
    super(props);
    this.increase = this.increase.bind(this);
    this.decrease = this.decrease.bind(this);
    this.onChangeOptions = this.onChangeOptions.bind(this);
    this.toggleIngredient = this.toggleIngredient.bind(this);
    this.setAmountIngredient = this.setAmountIngredient.bind(this);
    this.updateToCard = this.updateToCard.bind(this);
    this.checkCountSelectedIngredients = this.checkCountSelectedIngredients.bind(this);
    const state = props.location.state || {};
    this.state = {
      ingredients: List(),
      product: Map(),
      size: state.size,
      crustID: state.crustID,
      quantity: state.quantity || 1,
      sauceID: state.sauceID,
      index: state.index,
      defaultIngredients: List(),
      extraIngredientsMinus: state.extraIngredientsMinus ? List(state.extraIngredientsMinus) : List(),
      extraIngredientsPlus: state.extraIngredientsPlus ? List(state.extraIngredientsPlus) : List(),
      action: state.action || 'add',
      pizzaSizes: [],
      currentRestaurantId: props.currentRestaurantId
    };
  }

  static getDerivedStateFromProps(props, state) {
    let result = {};

    if (props.restaurant.pizzas) {
      const pizza = props.restaurant.pizzas.find(p => p.id === parseInt(props.match.params.productId, 10));

      if (pizza.is_special_pizza) {
        props.history.push(`/${props.restaurant.name_for_url}/products/pizza`);
      }

      if (_.isEmpty(pizza)) {
        return result;
      }

      const pizzaSizes = getSizeOfPizza(pizza);
      let size = state.size;
      if (!size) {
        const mediumSize = _.find(pizzaSizes, {value: DEFAULT_SIZE_PIZZA});
        if (!_.isUndefined(mediumSize)) {
          size = mediumSize.value;
        } else {
          size = pizzaSizes[0].value;
        }
      }
      let crustID = state.crustID;
      const crustes = getCrustOfPizza(pizza, size, state.language);
      if (!crustID && crustes.length > 0) {
        crustID = crustes[0].value;
      }
      result = {
        product: Map(pizza),
        pizzaSizes: List(pizzaSizes),
        defaultIngredients: List(_.cloneDeep(pizza.ingredients)),
        extraIngredientsMinus: state.extraIngredientsMinus,
        extraIngredientsPlus: state.extraIngredientsPlus,
        size: size,
        crustID: crustID,
      };
    }


    return result;
  }

  increase() {
    this.setState({
      quantity: this.state.quantity + 1
    });
  }

  decrease() {
    const quantity = this.state.quantity;
    this.setState({
      quantity: quantity > 1 ? quantity - 1 : 1
    });
  }

  onChangeOptions(selectedOption, key) {
    this.setState({
      [key]: selectedOption.value
    });
  }

  updateToCard() {
    const {state} = this;
    let ingredientsMinus = [];
    let ingredientsPlus = [];
    state.extraIngredientsMinus.toArray().forEach(obj => {
      ingredientsMinus.push({
        ingredient: {
          id: obj.ingredient.id
        },
        amount: obj.amount
      });
    });
    state.extraIngredientsPlus.toArray().forEach(obj => {
      ingredientsPlus.push({
        ingredient: {
          id: obj.ingredient.id
        },
        amount: obj.amount
      });
    });
    let data = {
      type: 'pizza',
      productId: state.product.get('id'),
      quantity: state.quantity,
      size: state.size,
      crustID: state.crustID,
      sauceID: state.sauceID,
      extraIngredientsMinus: ingredientsMinus,
      extraIngredientsPlus: ingredientsPlus,
    };
    if (state.action === 'add') {
      this.props.addToBasket(data);
    } else {
      data['index'] = state.index;
      this.props.updateBasket(data);
    }
    this.props.openBasket();
    if (this.props.history.length > 3) {
      this.props.history.goBack();
    } else {
      this.props.history.push(`/${this.props.restaurant.name_for_url}/products/pizza`)
    }
  }


  checkCountSelectedIngredients() {
    const {extraIngredientsPlus, extraIngredientsMinus, product} = this.state;
    let defaultIngredients = product.toObject().ingredients;
    let dataExtraPlus = extraIngredientsPlus ? extraIngredientsPlus.toArray() : [];
    let dataExtraMinus = extraIngredientsMinus ? extraIngredientsMinus.toArray() : [];
    let dataDefault = defaultIngredients ? defaultIngredients : [];
    let countExtraPlus = dataExtraPlus.reduce((sum, obj) => {
      return sum + parseInt(obj.amount, 10);
    }, 0);
    let countExtraMinus = dataExtraMinus.reduce((sum, obj) => {
      return sum + parseInt(obj.amount, 10);
    }, 0);
    let countDefault = dataDefault.reduce((sum, obj) => {
      return sum + parseInt(obj.amount, 10);
    }, 0);
    return countDefault + countExtraPlus - countExtraMinus;
  }

  toggleIngredient(checked, ingredient) {
    let {defaultIngredients, extraIngredientsMinus, extraIngredientsPlus} = this.state;
    const ingredientIndex = defaultIngredients.findIndex(extra => extra.ingredient.id === ingredient.id);
    const ingredientIndexFromPlus = extraIngredientsPlus.findIndex(extra => extra.ingredient.id === ingredient.id);
    const ingredientIndexFromMinus = extraIngredientsMinus.findIndex(extra => extra.ingredient.id === ingredient.id);
    const defaultIngredient = defaultIngredients.find(extra => extra.ingredient.id === ingredient.id);
    const extraIngredientPlus = extraIngredientsPlus.find(extra => extra.ingredient.id === ingredient.id);
    if (checked) {
      if (this.checkCountSelectedIngredients() >= LIMIT_INGREDIENTS) {
        return;
      }
    }
    if (ingredientIndex !== -1) {
      if (checked) {
        if (ingredientIndexFromMinus !== -1) {
          extraIngredientsMinus = extraIngredientsMinus.delete(ingredientIndexFromMinus);
        }
        if (ingredientIndexFromPlus !== -1) {
          extraIngredientsPlus = extraIngredientsPlus.delete(ingredientIndexFromPlus);
        }
        if (defaultIngredient.amount === '2') {
          extraIngredientsMinus = extraIngredientsMinus.push({
            ingredient: ingredient,
            amount: '1'
          });
        }
      } else {
        if (ingredientIndexFromMinus !== -1) {
          extraIngredientsMinus = extraIngredientsMinus.update(ingredientIndexFromMinus, extra => {
            extra.amount = parseInt(defaultIngredient.amount, 10) + parseInt(extraIngredientPlus ? extraIngredientPlus.amount : 0, 10);
            return extra;
          });
        } else {
          let amount = parseInt(defaultIngredient.amount, 10);
          if (ingredientIndexFromPlus !== -1) {
            amount += 1;
          }
          extraIngredientsMinus = extraIngredientsMinus.push({
            ingredient: ingredient,
            amount: amount
          });
        }
      }
    } else {
      // click on not default ingredient
      if (checked) {
        if (ingredientIndexFromPlus === -1) {
          extraIngredientsPlus = extraIngredientsPlus.push({
            ingredient: ingredient,
            amount: '1'
          });
        }
        if (ingredientIndexFromMinus !== -1) {
          extraIngredientsMinus = extraIngredientsMinus.delete(ingredientIndexFromMinus);
        }
      } else {
        if (ingredientIndexFromPlus !== -1) {
          extraIngredientsPlus = extraIngredientsPlus.delete(ingredientIndexFromPlus);
        } else {
          extraIngredientsMinus = extraIngredientsMinus.push({
            ingredient: ingredient,
            amount: '1'
          });
        }
      }
    }
    this.setState({
      extraIngredientsMinus: extraIngredientsMinus,
      extraIngredientsPlus: extraIngredientsPlus
    });
  }

  setAmountIngredient(ingredient, amount) {
    let {defaultIngredients, extraIngredientsPlus, extraIngredientsMinus} = this.state;
    const ingredientIndex = defaultIngredients.findIndex(extra => extra.ingredient.id === ingredient.id);
    const ingredientIndexFromPlus = extraIngredientsPlus.findIndex(extra => extra.ingredient.id === ingredient.id);
    const ingredientIndexFromMinus = extraIngredientsMinus.findIndex(extra => extra.ingredient.id === ingredient.id);
    const defaultIngredient = defaultIngredients.find(extra => extra.ingredient.id === ingredient.id);
    if (amount === '2' && this.checkCountSelectedIngredients() >= LIMIT_INGREDIENTS) {
      return;
    }
    if (ingredientIndex !== -1) {
      if (amount === '2') {
        if (ingredientIndexFromPlus !== -1) {
          extraIngredientsPlus = extraIngredientsPlus.delete(ingredientIndexFromPlus);
        } else {
          if (defaultIngredient.amount !== '2') {
            extraIngredientsPlus = extraIngredientsPlus.push({
              ingredient: ingredient,
              amount: '1'
            });
          }
        }
        if (ingredientIndexFromMinus !== -1) {
          extraIngredientsMinus = extraIngredientsMinus.delete(ingredientIndexFromMinus);
        }
      } else {
        if (ingredientIndexFromPlus !== -1) {
          extraIngredientsPlus = extraIngredientsPlus.delete(ingredientIndexFromPlus);
        }
        if (ingredientIndexFromMinus === -1 && defaultIngredient.amount === '2') {
          extraIngredientsMinus = extraIngredientsMinus.push({
            ingredient: ingredient,
            amount: '1'
          });
        }
      }
    } else if (ingredientIndexFromPlus !== -1) {
      extraIngredientsPlus = extraIngredientsPlus.update(ingredientIndexFromPlus, extra => {
        extra.amount = amount;
        return extra;
      });
    }
    this.setState({
      extraIngredientsMinus: extraIngredientsMinus,
      extraIngredientsPlus: extraIngredientsPlus,
    });
  }

  render() {
    const {product, size, crustID, sauceID, quantity, defaultIngredients, extraIngredientsPlus, extraIngredientsMinus} = this.state;
    const {sauces, ingredients, language, restaurant} = this.props;
    if (!List.isList(ingredients)) return <Spinner />;
    if (!List.isList(sauces)) return <Spinner />;
    if (product.isEmpty()) {
      return <Spinner/>;
    }
    return (
      <ProductCustomizeView
        product={product.toObject()}
        size={size}
        crustID={crustID}
        sauceID={sauceID}
        quantity={quantity}
        defaultIngredients={defaultIngredients.toArray()}
        extraIngredientsPlus={extraIngredientsPlus}
        extraIngredientsMinus={extraIngredientsMinus}
        ingredients={ingredients.toArray()}
        language={language}
        sauces={sauces}
        onChangeOptions={this.onChangeOptions}
        increase={this.increase}
        decrease={this.decrease}
        updateToCard={this.updateToCard}
        toggleIngredient={this.toggleIngredient}
        setAmountIngredient={this.setAmountIngredient}
        selectedCountIngredients={this.checkCountSelectedIngredients()}
        restaurant={restaurant}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    sauces: state.products.pizzaSauces,
    ingredients: state.products.ingredients,
    language: state.language.defaultLanguage,
    restaurant: state.restaurants.item || {},
    currentRestaurantId: state.restaurants.selectedId,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    updateBasket: bindActionCreators(basketActions.updateBasket, dispatch),
    openBasket: bindActionCreators(basketActions.openBasket, dispatch),
    addToBasket: bindActionCreators(basketActions.addToBasket, dispatch),
  }
}

ProductCustomizeScreen.propTypes = {
  sauces: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  ingredients: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(translate('translations')(ProductCustomizeScreen));


// WEBPACK FOOTER //
// ./src/containers/ProductCustomizeScreen.js